export default "__VITE_ASSET__D00GMkjx__"